"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f1575 = void 0;
exports.f1575 = {
    "العربية": [
        405,
        406,
        407,
        408,
        410,
        411,
        412,
        413,
        414,
        415,
        416,
        417,
        418,
        419,
        420,
        421,
        422,
        423,
        424,
        425,
        426,
        427,
        428,
        429,
        430,
        432,
        433,
        434
    ],
    "العربية الفصحى الحديثة": [
        406
    ],
    "الفصحى": [
        406
    ],
    "الحديثة": [
        406
    ],
    "اردو": [
        7987,
        7990
    ],
    "اوزبیک": [
        8039
    ]
};
